/* import __COLOCATED_TEMPLATE__ from './fly-snackbar.hbs.js'; */
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
export let SnackbarState = /*#__PURE__*/function (SnackbarState) {
  SnackbarState["Info"] = "info";
  SnackbarState["Error"] = "error";
  return SnackbarState;
}({});
export let SnackbarLayout = /*#__PURE__*/function (SnackbarLayout) {
  SnackbarLayout["Condensed"] = "condensed";
  SnackbarLayout["Expanded"] = "expanded";
  return SnackbarLayout;
}({});
/**
  FlySnackbar is a component displays a short amount of information to the user
  with minimal disruption.

  Without an action, it takes a single block of content.

  ```hbs
  <FlySnackbar
    /@state={{SnackbarState.Info}}
    /@layout={{SnackbarLayout.Condensed}}
    /@onClose={{this.onSnackbarClose}}
  >
    <p>Your model was successfully saved
  </FlySnackbar>
  ```

  If you want to display a button to trigger an action, then you can use named
  blocks with a block argument in the `action` block, which is an object that
  contains a button component with the correct class and type already applied.
  You may override any attribute of the button directly here.

  ```hbs
  <FlySnackbar
    /@state={{SnackbarState.Info}}
    /@layout={{SnackbarLayout.Condensed}}
    /@onClose={{this.onSnackbarClose}}
  >
    <:default>
      <p>Your model was successfully saved.
    </:default>
    <:action as |sba|>
      <sba.button {{on "click" this.undoSave}}>Undo</sba.button>
    </:action>
  </FlySnackbar>
  ```

  @class FlySnackbar
  @public
 */
export default class FlySnackbar extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "SnackbarLayout", SnackbarLayout);
    _defineProperty(this, "SnackbarState", SnackbarState);
  }
  get state() {
    return this.args.state ?? SnackbarState.Info;
  }
  get layout() {
    return this.args.layout ?? SnackbarLayout.Condensed;
  }
  get isError() {
    return this.state === SnackbarState.Error;
  }
}